import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { CanvasMenuPosition } from './useCanvasContextMenu'

interface CanvasContextMenuProps {
  /** Where the empty canvas was right-clicked; null = closed. */
  menu: CanvasMenuPosition | null
  onClose: () => void
  /** "Create entity here": the graph position the new node should take. */
  onCreateEntity: (position: { x: number; y: number }) => void
}

/**
 * The empty-canvas context menu, anchored at the right-click. Nodes and edges
 * keep their ring menu; this one is for what the canvas itself can do.
 */
export function CanvasContextMenu({ menu, onClose, onCreateEntity }: CanvasContextMenuProps) {
  const { t } = useTranslation()
  if (!menu) return null
  return (
    <DropdownMenu open onOpenChange={open => !open && onClose()}>
      <DropdownMenuTrigger asChild>
        <span
          aria-hidden
          className="pointer-events-none absolute size-px"
          style={{ left: menu.rendered.x, top: menu.rendered.y }}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={2} className="w-auto min-w-48">
        <DropdownMenuItem
          onSelect={() => {
            onCreateEntity(menu.model)
            onClose()
          }}
        >
          <Plus className="size-4" aria-hidden />
          {t('manualGraph.canvasMenu.createEntityHere')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
